module.exports = __webpack_public_path__ + "media/newstyle/images/icon-open-quote-73b4290ee8da4db4299993d97bf9e0fe.svg";